import querystring from 'querystring';

import { extend } from 'lodash';

const makeQueryString = (oldParams, mergeParams) => {
  const newParams = extend({}, oldParams, mergeParams);
  return querystring.stringify(newParams);
};

export default makeQueryString;
